function ez_lazyLoad() {

    var image = $('._ez_lazy-image');

    if ( image.length ) {
        image.lazyload({
            effect : "fadeIn"
        });
    }
}

